// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignInForm_Form__1ZT3l","FormElements":"SignInForm_FormElements__1Cjb4"};